// // import React, { useState, useEffect } from "react";
// // import ReactCrop, { Crop } from "react-image-crop";
// // import "react-image-crop/dist/ReactCrop.css";
// // import { Box, Button, Stack, Modal } from "@mui/material";
// // import { Height } from "@mui/icons-material";

// // interface CropperModalProps {
// //   file: File | string; // Either File object or live URL string
// //   onClose: () => void;
// //   onSave: (croppedFile: File) => void;
// //   reportgroup: string;
// // }

// // export default function CropperModal({ file, onClose, onSave, reportgroup }: CropperModalProps) {
// //   const [rotation, setRotation] = useState<number>(0);
// //   const [imageSrc, setImageSrc] = useState<string>("");
// //   const [imageElement, setImageElement] = useState<HTMLImageElement | null>(null);
// //   const [rotatedSize, setRotatedSize] = useState<{ width: number; height: number }>({ width: 0, height: 0 });

// //   console.log("FIle", file)
// //   const [crop, setCrop] = useState<Crop>({
// //     unit: "px",
// //     width: 200,
// //     height: 200,
// //     x: 0,
// //     y: 0,
// //   });


// //   const getRotatedSize = (width: number, height: number, rotation: number) => {
// //     const angle = (rotation * Math.PI) / 180;
// //     return {
// //       width: Math.abs(width * Math.cos(angle)) + Math.abs(height * Math.sin(angle)),
// //       height: Math.abs(width * Math.sin(angle)) + Math.abs(height * Math.cos(angle)),
// //     };
// //   };

// //   useEffect(() => {
// //     if (imageElement) {
// //       const { naturalWidth, naturalHeight } = imageElement;
// //       setRotatedSize(getRotatedSize(naturalWidth, naturalHeight, rotation));
// //     }
// //   }, [rotation, imageElement]);

// //   // Load image from File or live URL
// //   useEffect(() => {
// //     if (!file) return;

// //     const loadImage = async () => {
// //       try {
// //         if (typeof file === "string") {
// //           // Live URL: fetch and convert to File, then create Object URL
// //           const res = await fetch(file);
// //           const blob = await res.blob();
// //           const fileObj = new File([blob], "image.jpg", { type: blob.type });
// //           setImageSrc(URL.createObjectURL(fileObj));
// //         } else {
// //           // Local File
// //           const reader = new FileReader();
// //           reader.onload = () => setImageSrc(reader.result as string);
// //           reader.readAsDataURL(file);
// //         }
// //       } catch (err) {
// //         console.error("Failed to load image:", err);
// //         if (typeof file === "string") setImageSrc(file); // fallback to URL
// //       }
// //     };

// //     loadImage();
// //   }, [file]);


// //   // useEffect(() => {
// //   //   if (isAldi && imageElement) {
// //   //     const imgWidth = imageElement.naturalWidth;
// //   //     const imgHeight = imageElement.naturalHeight;

// //   //     // Start with 30% of image height
// //   //     let cropHeight = imgHeight * 0.3;
// //   //     let cropWidth = (cropHeight * 4) / 3;

// //   //     // If width exceeds image width, shrink to fit inside
// //   //     if (cropWidth > imgWidth) {
// //   //       cropWidth = imgWidth * 0.9; // 90% of width max
// //   //       cropHeight = (cropWidth * 3) / 4; // recalc height to keep 4:3
// //   //     }

// //   //     // Center the crop box
// //   //     const x = 0;
// //   //     const y = 0;

// //   //     setCrop({
// //   //       unit: "px",
// //   //       width: cropWidth,
// //   //       height: cropHeight,
// //   //       x,
// //   //       y,
// //   //     });
// //   //   }
// //   // }, [isAldi, imageElement]);
// //   // Cropper logic
// //   const getCroppedImage = async (): Promise<File | null> => {
// //     if (!imageElement) return null;

// //     const scaleX = imageElement.naturalWidth / imageElement.width;
// //     const scaleY = imageElement.naturalHeight / imageElement.height;

// //     const cropX = crop.x * scaleX;
// //     const cropY = crop.y * scaleY;
// //     const cropWidth = crop.width * scaleX;
// //     const cropHeight = crop.height * scaleY;

// //     const radians = (rotation * Math.PI) / 180;
// //     const sin = Math.abs(Math.sin(radians));
// //     const cos = Math.abs(Math.cos(radians));
// //     const newWidth = cropWidth * cos + cropHeight * sin;
// //     const newHeight = cropWidth * sin + cropHeight * cos;

// //     const canvas = document.createElement("canvas");
// //     canvas.width = newWidth;
// //     canvas.height = newHeight;

// //     const ctx = canvas.getContext("2d");
// //     if (!ctx) return null;

// //     ctx.translate(canvas.width / 2, canvas.height / 2);
// //     ctx.rotate(radians);
// //     ctx.drawImage(
// //       imageElement,
// //       cropX,
// //       cropY,
// //       cropWidth,
// //       cropHeight,
// //       -cropWidth / 2,
// //       -cropHeight / 2,
// //       cropWidth,
// //       cropHeight
// //     );

// //     return new Promise((resolve) => {
// //       canvas.toBlob((blob) => {
// //         if (!blob) return;
// //         resolve(new File([blob], "cropped.jpg", { type: "image/jpeg" }));
// //       }, "image/jpeg");
// //     });
// //   };

// //   const handleSave = async () => {
// //     const croppedFile = await getCroppedImage();
// //     if (croppedFile) {
// //       // console.log("Cropped FIle", croppedFile)
// //       const croppedUrl = URL.createObjectURL(croppedFile);
// //       setImageSrc(croppedUrl); // update preview
// //       onSave(croppedFile);     // send File to parent
// //     }
// //   };

// //   function getScale(angle: number) {
// //     const rad = (angle * Math.PI) / 180;
// //     const sin = Math.abs(Math.sin(rad));
// //     const cos = Math.abs(Math.cos(rad));

// //     // Fit rotated rect into original box
// //     const scale = 1 / Math.max(sin + cos, 1);
// //     return scale;
// //   }

// //   return (
// //     <Modal open onClose={onClose}>
// //       <Box
// //         id="cropper-modal-box"
// //         sx={{
// //           position: "absolute" as "absolute",
// //           top: "50%",
// //           left: "50%",
// //           transform: "translate(-50%, -50%)",
// //           maxWidth: "90vw",
// //           maxHeight: "90vh",
// //           bgcolor: "background.paper",
// //           p: 3,
// //           borderRadius: 2,
// //           boxShadow: 24,
// //           display: "flex",
// //           flexDirection: "column",
// //           alignItems: "center",
// //         }}
// //       >
// //         {imageSrc && (
// //           <ReactCrop crop={crop}
// //             style={{ overflow: 'auto' }}
// //             onChange={(c) => {
// //               setCrop(c);
// //             }}>
// //             <img
// //               src={imageSrc}
// //               crossOrigin="anonymous"
// //               alt="to crop"
// //               ref={setImageElement}
// //               // className="h-100 w-100"
// //               onLoad={(e) => setImageElement(e.currentTarget)}
// //               style={{
// //                 transform: `rotate(${rotation}deg)`,
// //                 transformOrigin: "center center",
// //                 width: rotatedSize.width,
// //                 height: rotatedSize.height,
// //                 objectFit:'contain'
// //               }}
// //             />
// //           </ReactCrop>
// //         )}

// //         {/* Rotate buttons */}
// //         <Stack direction="row" spacing={2} justifyContent="center" mt={2}>
// //           <Button variant="outlined" onClick={() => setRotation((prev) => (prev - 90 + 360) % 360)}>
// //             Rotate Left
// //           </Button>
// //           <Button variant="outlined" onClick={() => setRotation((prev) => (prev + 90) % 360)}>
// //             Rotate Right
// //           </Button>
// //         </Stack>

// //         {/* Action buttons */}
// //         <Box mt={3} display="flex" justifyContent="center" gap={1}>
// //           <Button variant="contained" onClick={handleSave}>
// //             Save
// //           </Button>
// //           <Button variant="outlined" onClick={onClose}>
// //             Cancel
// //           </Button>
// //         </Box>
// //       </Box>
// //     </Modal>
// //   );
// // }
// import React, { useState, useEffect } from "react";
// import ReactCrop, { Crop } from "react-image-crop";
// import "react-image-crop/dist/ReactCrop.css";
// import { Box, Button, Stack, Modal } from "@mui/material";
// import { Height } from "@mui/icons-material";

// interface CropperModalProps {
//   file: File | string; // Either File object or live URL string
//   onClose: () => void;
//   onSave: (croppedFile: File) => void;
//   reportgroup: string;
// }

// export default function CropperModal({ file, onClose, onSave, reportgroup }: CropperModalProps) {
//   const [rotation, setRotation] = useState<number>(0);
//   const [imageSrc, setImageSrc] = useState<string>("");
//   const [imageElement, setImageElement] = useState<HTMLImageElement | null>(null);
//   const [rotatedSize, setRotatedSize] = useState<{ width: number; height: number }>({ width: 0, height: 0 });

//   console.log("FIle", file)
//   const [crop, setCrop] = useState<Crop>({
//     unit: "px",
//     width: 200,
//     height: 200,
//     x: 0,
//     y: 0,
//   });


//   const getRotatedSize = (width: number, height: number, rotation: number) => {
//     const angle = (rotation * Math.PI) / 180;
//     return {
//       width: Math.abs(width * Math.cos(angle)) + Math.abs(height * Math.sin(angle)),
//       height: Math.abs(width * Math.sin(angle)) + Math.abs(height * Math.cos(angle)),
//     };
//   };

//   useEffect(() => {
//     if (imageElement) {
//       const { naturalWidth, naturalHeight } = imageElement;
//       setRotatedSize(getRotatedSize(naturalWidth, naturalHeight, rotation));
//     }
//   }, [rotation, imageElement]);

//   // Load image from File or live URL
//   useEffect(() => {
//     if (!file) return;

//     const loadImage = async () => {
//       try {
//         if (typeof file === "string") {
//           // Live URL: fetch and convert to File, then create Object URL
//           const res = await fetch(file);
//           const blob = await res?.blob();
//           const fileObj = new File([blob], "image.jpg", { type: blob.type });
//           setImageSrc(URL.createObjectURL(fileObj));
//         } else {
//           // Local File
//           const reader = new FileReader();
//           reader.onload = () => setImageSrc(reader.result as string);
//           reader.readAsDataURL(file);
//         }
//       } catch (err) {
//         console.error("Failed to load image:", err);
//         if (typeof file === "string") setImageSrc(file); // fallback to URL
//       }
//     };

//     loadImage();
//   }, [file]);


//   // useEffect(() => {
//   //   if (isAldi && imageElement) {
//   //     const imgWidth = imageElement.naturalWidth;
//   //     const imgHeight = imageElement.naturalHeight;

//   //     // Start with 30% of image height
//   //     let cropHeight = imgHeight * 0.3;
//   //     let cropWidth = (cropHeight * 4) / 3;

//   //     // If width exceeds image width, shrink to fit inside
//   //     if (cropWidth > imgWidth) {
//   //       cropWidth = imgWidth * 0.9; // 90% of width max
//   //       cropHeight = (cropWidth * 3) / 4; // recalc height to keep 4:3
//   //     }

//   //     // Center the crop box
//   //     const x = 0;
//   //     const y = 0;

//   //     setCrop({
//   //       unit: "px",
//   //       width: cropWidth,
//   //       height: cropHeight,
//   //       x,
//   //       y,
//   //     });
//   //   }
//   // }, [isAldi, imageElement]);
//   // Cropper logic



//   // const getCroppedImage = async (): Promise<File | null> => {
//   //   if (!imageElement) return null;

//   //   const scaleX = imageElement.naturalWidth / imageElement.width;
//   //   const scaleY = imageElement.naturalHeight / imageElement.height;

//   //   const cropX = crop.x * scaleX;
//   //   const cropY = crop.y * scaleY;
//   //   const cropWidth = crop.width * scaleX;
//   //   const cropHeight = crop.height * scaleY;

//   //   const radians = (rotation * Math.PI) / 180;
//   //   const sin = Math.abs(Math.sin(radians));
//   //   const cos = Math.abs(Math.cos(radians));
//   //   const newWidth = cropWidth * cos + cropHeight * sin;
//   //   const newHeight = cropWidth * sin + cropHeight * cos;

//   //   const canvas = document.createElement("canvas");
//   //   canvas.width = newWidth;
//   //   canvas.height = newHeight;

//   //   const ctx = canvas.getContext("2d");
//   //   if (!ctx) return null;

//   //   ctx.translate(canvas.width / 2, canvas.height / 2);
//   //   ctx.rotate(radians);
//   //   ctx.drawImage(
//   //     imageElement,
//   //     cropX,
//   //     cropY,
//   //     cropWidth,
//   //     cropHeight,
//   //     -cropWidth / 2,
//   //     -cropHeight / 2,
//   //     cropWidth,
//   //     cropHeight
//   //   );

//   //   return new Promise((resolve) => {
//   //     canvas.toBlob((blob) => {
//   //       if (!blob) return;
//   //       resolve(new File([blob], "cropped.jpg", { type: "image/jpeg" }));
//   //     }, "image/jpeg");
//   //   });
//   // };

//   // const getCroppedImage = async (): Promise<File | null> => {
//   //   if (!imageElement) return null;

//   //   const naturalWidth = imageElement.naturalWidth;
//   //   const naturalHeight = imageElement.naturalHeight;

//   //   // Create a canvas to hold the rotated image
//   //   const rotatedCanvas = document.createElement("canvas");
//   //   const rotatedCtx = rotatedCanvas.getContext("2d");
//   //   if (!rotatedCtx) return null;

//   //   // Calculate the new size of the rotated image
//   //   const { width: rotatedWidth, height: rotatedHeight } = getRotatedSize(naturalWidth, naturalHeight, rotation);

//   //   rotatedCanvas.width = rotatedWidth;
//   //   rotatedCanvas.height = rotatedHeight;

//   //   // Center and rotate the canvas context
//   //   rotatedCtx.translate(rotatedWidth / 2, rotatedHeight / 2);
//   //   rotatedCtx.rotate((rotation * Math.PI) / 180);

//   //   // Draw the original, unrotated image
//   //   rotatedCtx.drawImage(imageElement, -naturalWidth / 2, -naturalHeight / 2);

//   //   // Now, create the final cropped canvas
//   //   const finalCanvas = document.createElement("canvas");
//   //   const finalCtx = finalCanvas.getContext("2d");
//   //   if (!finalCtx) return null;

//   //   // Scale the crop coordinates from the display size to the natural size
//   //   const scaleX = naturalWidth / imageElement.width;
//   //   const scaleY = naturalHeight / imageElement.height;

//   //   const cropX = crop.x * scaleX;
//   //   const cropY = crop.y * scaleY;
//   //   const cropWidth = crop.width * scaleX;
//   //   const cropHeight = crop.height * scaleY;

//   //   // Calculate crop coordinates on the rotated canvas
//   //   const unrotatedCropX = crop.x * scaleX;
//   //   const unrotatedCropY = crop.y * scaleY;

//   //   // Transform coordinates back to the unrotated image space
//   //   const rad = (rotation * Math.PI) / 180;
//   //   const cos = Math.cos(rad);
//   //   const sin = Math.sin(rad);

//   //   const rotatedCropX = (unrotatedCropX - naturalWidth / 2) * cos + (unrotatedCropY - naturalHeight / 2) * sin + rotatedWidth / 2;
//   //   const rotatedCropY = -(unrotatedCropX - naturalWidth / 2) * sin + (unrotatedCropY - naturalHeight / 2) * cos + rotatedHeight / 2;

//   //   finalCanvas.width = cropWidth;
//   //   finalCanvas.height = cropHeight;

//   //   // Now draw the cropped portion from the rotated image
//   //   finalCtx.drawImage(rotatedCanvas, rotatedCropX, rotatedCropY, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);

//   //   return new Promise((resolve) => {
//   //     finalCanvas.toBlob((blob) => {
//   //       if (!blob) return;
//   //       resolve(new File([blob], "cropped.jpg", { type: "image/jpeg" }));
//   //     }, "image/jpeg");
//   //   });
//   // };

//   const getCroppedImage = async (): Promise<File | null> => {
//   if (!imageElement) return null;

//   const naturalWidth = imageElement.naturalWidth;
//   const naturalHeight = imageElement.naturalHeight;

//   // scale from displayed image back to natural size
//   const scaleX = naturalWidth / imageElement.width;
//   const scaleY = naturalHeight / imageElement.height;

//   const cropX = crop.x * scaleX;
//   const cropY = crop.y * scaleY;
//   const cropWidth = crop.width * scaleX;
//   const cropHeight = crop.height * scaleY;

//   // create canvas of crop size
//   const canvas = document.createElement("canvas");
//   canvas.width = cropWidth;
//   canvas.height = cropHeight;

//   const ctx = canvas.getContext("2d");
//   if (!ctx) return null;

//   // move canvas origin to center (for rotation)
//   ctx.translate(canvas.width / 2, canvas.height / 2);
//   ctx.rotate((rotation * Math.PI) / 180);

//   // draw original image, shifted so crop area aligns
//   ctx.drawImage(
//     imageElement,
//     cropX,
//     cropY,
//     cropWidth,
//     cropHeight,
//     -cropWidth / 2,
//     -cropHeight / 2,
//     cropWidth,
//     cropHeight
//   );

//   return new Promise((resolve) => {
//     canvas.toBlob((blob) => {
//       if (!blob) return;
//       resolve(new File([blob], "cropped.jpg", { type: "image/jpeg" }));
//     }, "image/jpeg");
//      canvas?.toDataURL("image/jpeg");
//   });
// };

//   const handleSave = async () => {
//     const croppedFile = await getCroppedImage();
//     if (croppedFile) {
//       // console.log("Cropped FIle", croppedFile)
//       const croppedUrl = URL.createObjectURL(croppedFile);
//       setImageSrc(croppedUrl); // update preview
//       onSave(croppedFile);     // send File to parent
//     }
//   };

//   function getScale(angle: number) {
//     const rad = (angle * Math.PI) / 180;
//     const sin = Math.abs(Math.sin(rad));
//     const cos = Math.abs(Math.cos(rad));

//     // Fit rotated rect into original box
//     const scale = 1 / Math.max(sin + cos, 1);
//     return scale;
//   }

//   return (
//     <Modal open onClose={onClose}>
//       <Box
//         id="cropper-modal-box"
//         sx={{
//           position: "absolute" as "absolute",
//           top: "50%",
//           left: "50%",
//           transform: "translate(-50%, -50%)",
//           maxWidth: "90vw",
//           maxHeight: "90vh",
//           bgcolor: "background.paper",
//           p: 1,
//           borderRadius: 2,
//           boxShadow: 24,
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           // overflow:'hidden',
//         }}
//       >
//         <Box sx={{ maxHeight: '700px', overflow: "auto" }}>
//           {imageSrc && (
//             <ReactCrop crop={crop}
//               style={{
//                 transform: `rotate(${rotation}deg)`,
//                 transformOrigin: "center center",

//               }}
//               onChange={(c) => {
//                 setCrop(c);
//               }}>
//               <img
//                 src={imageSrc}
//                 alt="to crop"
//                 ref={setImageElement}
//                 // className="h-100 w-100"
//                 onLoad={(e) => setImageElement(e.currentTarget)}
//                 style={{
//                   width: "100%",
//                   height: "auto",
//                   objectFit: "contain",
//                 }}
//               />
//             </ReactCrop>
//           )}
//         </Box>

//         {/* Rotate buttons */}
//         <Stack direction="row" spacing={2} justifyContent="center" mt={2}>
//           <Button variant="outlined" onClick={() => setRotation((prev) => (prev - 90 + 360) % 360)}>
//             Rotate Left
//           </Button>
//           <Button variant="outlined" onClick={() => setRotation((prev) => (prev + 90) % 360)}>
//             Rotate Right
//           </Button>
//         </Stack>

//         {/* Action buttons */}
//         <Box mt={3} display="flex" justifyContent="center" gap={1}>
//           <Button variant="contained" onClick={handleSave}>
//             Save
//           </Button>
//           <Button variant="outlined" onClick={onClose}>
//             Cancel
//           </Button>
//         </Box>
//       </Box>
//     </Modal>
//   );
// }

import React, { useState, useCallback, useEffect } from "react";
import Cropper from "react-easy-crop";
import { Modal, Box, Button, ToggleButton, ToggleButtonGroup, CircularProgress } from "@mui/material";
import axios from 'axios'
import { uploadImageBuffer } from "../../apiService/Core/ApiEndPoint.tsx";
import { useDispatch, useSelector } from "react-redux";
import store from "../../Redux/Store.tsx";
import { hideLoading, showLoading } from "../../Redux/loadingSlice.tsx";
import Loading from "../Loader/Loading.tsx";

interface CropperModalProps {
  file: File | string;
  open: boolean;
  onClose: () => void;
  onSave: (file: File) => void;
  reportgroup: string;
  isAdmin: boolean
}

const CropperModal: React.FC<CropperModalProps> = ({
  file,
  open,
  onClose,
  onSave,
  reportgroup,
  isAdmin

}) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [loading, setloading] = useState(false)
  const [rotation, setRotation] = useState(0);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<any>(null);
  const [imageSrc, setImageSrc] = useState<any>(
    typeof file === "string" ? file : URL.createObjectURL(file)
  );
  const [aspect, setAspect] = useState<number | undefined>(1);
  const [cropMode, setCropMode] = useState(false);
  const dispatch = useDispatch()


  function parseS3Url(url: string) {
    const parsed = new URL(url);
    const parts = parsed.pathname.split("/").filter(Boolean);
    const bucket = parts[0];
    let key = parts.slice(1).join("/");
    key = key.replace(/\u202f/g, " ");
    return { bucket, key };
  }

  // useEffect(() => {
  // const fetchImage = async () => {
  //   try {
  //     const presignedUrl = imageSrc;
  //     const { bucket, key } = parseS3Url(presignedUrl);
  //     const res = await axios.get(
  //       `${uploadImageBuffer}?bucket=${encodeURIComponent(
  //         bucket
  //       )}&key=${encodeURIComponent(key)}`,
  //       { responseType: "blob" } // important to get blob
  //     );
  //     const blobUrl = URL.createObjectURL(res.data);
  //     setImageSrc(blobUrl);
  //   } catch (err) {
  //     console.log("Failed to fetch image:", err);
  //   }
  // };

  //   fetchImage();
  // }, []);
  useEffect(() => {
    const fetchImage = async () => {
      setloading(true)
      try {
        const presignedUrl = imageSrc;
        const { bucket, key } = parseS3Url(presignedUrl);

        const safeKey = encodeURIComponent(key);
        const safeBucket = encodeURIComponent(bucket);

        const res = await axios.get(
          `${uploadImageBuffer}?bucket=${safeBucket}&key=${safeKey}`,
          { responseType: "blob" }
        );
        const blobUrl = URL.createObjectURL(res.data);
        setImageSrc(blobUrl);
      } catch (err) {
        console.log("Failed to fetch image:", err);
      }
      finally {
        setloading(false)
      }
    };

    fetchImage();
  }, []);

  const onCropComplete = useCallback((_croppedArea: any, croppedPixels: any) => {
    setCroppedAreaPixels(croppedPixels);
  }, []);

  const createImage = (url: string): Promise<HTMLImageElement> =>
    new Promise((resolve, reject) => {
      const image = new Image();
      image.crossOrigin = "anonymous";
      image.onload = () => resolve(image);
      image.onerror = reject;
      image.src = url;
    });

  const getCroppedImg = async (): Promise<File | null> => {
    try {
      const image = await createImage(imageSrc);

      const createRotatedImage = (image: HTMLImageElement, rotation = 0) => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d")!;
        const radians = (rotation * Math.PI) / 180;
        const sin = Math.abs(Math.sin(radians));
        const cos = Math.abs(Math.cos(radians));
        const width = image.naturalWidth;
        const height = image.naturalHeight;

        const rotatedWidth = width * cos + height * sin;
        const rotatedHeight = width * sin + height * cos;
        canvas.width = rotatedWidth;
        canvas.height = rotatedHeight;

        ctx.translate(rotatedWidth / 2, rotatedHeight / 2);
        ctx.rotate(radians);
        ctx.drawImage(image, -width / 2, -height / 2);

        return canvas;
      };

      const rotatedCanvas = createRotatedImage(image, rotation);

      // ❌ If crop mode is off → ignore crop area
      if (!cropMode) {
        return new Promise<File | null>((resolve) => {
          rotatedCanvas?.toBlob((blob) => {
            console.log("Bloob", blob);
            if (blob)
              resolve(new File([blob], rotation !== 0 ? "rotated.jpg" : "original.jpg", { type: "image/jpeg" }));
            else resolve(null);
          }, "image/jpeg");
        });
      }

      // ✅ Crop mode is ON → crop normally
      if (!croppedAreaPixels) return null;

      const { x, y, width, height } = croppedAreaPixels;
      const outputCanvas = document.createElement("canvas");
      outputCanvas.width = width;
      outputCanvas.height = height;
      const outputCtx = outputCanvas.getContext("2d")!;
      outputCtx.drawImage(rotatedCanvas, x, y, width, height, 0, 0, width, height);

      return new Promise<File | null>((resolve) => {
        outputCanvas.toBlob((blob) => {
          if (blob)
            resolve(new File([blob], "cropped.jpg", { type: "image/jpeg" }));
          else resolve(null);
        }, "image/jpeg");
      });
    } catch (e) {
      console.error("Crop error:", e);
      return null;
    }
  };


  const handleSave = async () => {
    const croppedFile = await getCroppedImg();
    if (croppedFile) {
      const croppedUrl = URL.createObjectURL(croppedFile);
      setImageSrc(croppedUrl);
      onSave(croppedFile);
      onClose();
    }
  };

  return (
    <Modal open={true} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 500,
          height: 700,
          bgcolor: "white",
          boxShadow: 24,
          p: 2,
        }}
      >
        {/* <div style={{ position: "relative", width: "100%", height: "80%" }}>
          <Cropper
            image={imageSrc}
            crop={crop}
            zoom={zoom}
            rotation={rotation}
            aspect={cropMode ? aspect : undefined}
            onCropChange={setCrop}
            onRotationChange={setRotation}
            onZoomChange={setZoom}
            onCropComplete={onCropComplete}
            cropShape={cropMode ? "rect" : "none"}
            showGrid={cropMode}
            restrictPosition={false}
          />
        </div> */}

        <div style={{ position: "relative", width: "100%", height: "80%", background: "#000" }}>
          {cropMode ? (
            <Cropper
              image={imageSrc}
              crop={crop}
              zoom={zoom}
              rotation={rotation}
              aspect={aspect}
              onCropChange={setCrop}
              onRotationChange={setRotation}
              onZoomChange={setZoom}
              onCropComplete={onCropComplete}
              cropShape="rect"
              showGrid={true}
              restrictPosition={false}
            />
          ) : (
            <img
              src={imageSrc}
              alt="Preview"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                transform: `rotate(${rotation}deg)`,
              }}
            />
          )}
        </div>


        {cropMode && (
          <Box mt={2} display="flex" justifyContent="center">
            <ToggleButtonGroup
              value={aspect || ""}
              exclusive
              onChange={(_, newAspect) => {
                if (newAspect !== null) setAspect(newAspect);
              }}
              aria-label="aspect ratio"
            >
              <ToggleButton value={1}>1:1</ToggleButton>
              <ToggleButton value={4 / 3}>4:3</ToggleButton>
              <ToggleButton value={16 / 9}>16:9</ToggleButton>
              <ToggleButton value={9 / 16}>9:16</ToggleButton>
            </ToggleButtonGroup>
          </Box>
        )}

        <Box display="flex" justifyContent="space-around" alignItems="center" mt={2}>
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>

          {/* {!cropMode  && (
            <Button variant="contained" onClick={() => setCropMode(true)}>
              Crop
            </Button>
          )} */}
          {!cropMode && (
            (reportgroup === "ALDI" ? isAdmin : true) && (
              <Button variant="contained" onClick={() => setCropMode(true)}>
                Crop
              </Button>
            )
          )}

          {cropMode && (
            <Button variant="contained" onClick={handleSave}>
              Save Crop
            </Button>
          )}

          <Button variant="outlined" onClick={() => setRotation((r) => r + 90)}>
            Rotate
          </Button>
        </Box>
        <Box className='w-100 d-flex justify-content-center mt-4'>
          {!cropMode && rotation !== 0 && (
            !loading ? (
              <Button variant="contained" className="d-block button-main" onClick={handleSave}>
                Save Rotation
              </Button>
            ) :
              (
                <CircularProgress size={24} color="inherit" />
              )
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default CropperModal;

// import React, { useState, useCallback, useEffect } from "react";
// import Cropper from "react-easy-crop";
// import { Modal, Box, Button, ToggleButton, ToggleButtonGroup } from "@mui/material";

// interface CropperModalProps {
//   file: File | string;
//   open: boolean;
//   onClose: () => void;
//   onSave: (file: File) => void;
// }

// const CropperModal: React.FC<CropperModalProps> = ({
//   file,
//   open,
//   onClose,
//   onSave,
// }) => {
//   const [crop, setCrop] = useState({ x: 0, y: 0 });
//   const [zoom, setZoom] = useState(1);
//   const [rotation, setRotation] = useState(0);
//   const [croppedAreaPixels, setCroppedAreaPixels] = useState<any>(null);
//   const [imageSrc, setImageSrc] = useState<string>("");
//   const [aspect, setAspect] = useState<number | undefined>(1);
//   const [cropMode, setCropMode] = useState(false);

//   // --- FETCH IMAGE AS BLOB FIRST ---
//   useEffect(() => {
//     const loadImage = async () => {
//       try {
//         if (typeof file === "string") {
//           const response = await fetch(file, { mode: "cors" });
//           const blob = await response.blob();
//           setImageSrc(URL.createObjectURL(blob));
//         } else {
//           setImageSrc(URL.createObjectURL(file));
//         }
//       } catch (err) {
//         console.error("Error loading image:", err);
//       }
//     };
//     loadImage();
//   }, [file]);

//   const onCropComplete = useCallback((_croppedArea: any, croppedPixels: any) => {
//     setCroppedAreaPixels(croppedPixels);
//   }, []);

//   const createImage = (url: string): Promise<HTMLImageElement> =>
//     new Promise((resolve, reject) => {
//       const image = new Image();
//       image.crossOrigin = "anonymous"; // ensure CORS
//       image.onload = () => resolve(image);
//       image.onerror = reject;
//       image.src = url;
//     });

//   const getCroppedImg = async (): Promise<File | null> => {
//     try {
//       const image = await createImage(imageSrc);

//       const createRotatedImage = (image: HTMLImageElement, rotation = 0) => {
//         const canvas = document.createElement("canvas");
//         const ctx = canvas.getContext("2d")!;
//         const radians = (rotation * Math.PI) / 180;
//         const sin = Math.abs(Math.sin(radians));
//         const cos = Math.abs(Math.cos(radians));
//         const width = image.naturalWidth;
//         const height = image.naturalHeight;

//         const rotatedWidth = width * cos + height * sin;
//         const rotatedHeight = width * sin + height * cos;
//         canvas.width = rotatedWidth;
//         canvas.height = rotatedHeight;

//         ctx.translate(rotatedWidth / 2, rotatedHeight / 2);
//         ctx.rotate(radians);
//         ctx.drawImage(image, -width / 2, -height / 2);

//         return canvas;
//       };

//       const rotatedCanvas = createRotatedImage(image, rotation);

//       if (!cropMode) {
//         return new Promise<File | null>((resolve) => {
//           rotatedCanvas.toBlob((blob) => {
//             if (blob)
//               resolve(
//                 new File(
//                   [blob],
//                   rotation !== 0 ? "rotated.jpg" : "original.jpg",
//                   { type: "image/jpeg" }
//                 )
//               );
//             else resolve(null);
//           }, "image/jpeg");
//         });
//       }

//       if (!croppedAreaPixels) return null;

//       const { x, y, width, height } = croppedAreaPixels;
//       const outputCanvas = document.createElement("canvas");
//       outputCanvas.width = width;
//       outputCanvas.height = height;
//       const outputCtx = outputCanvas.getContext("2d")!;
//       outputCtx.drawImage(rotatedCanvas, x, y, width, height, 0, 0, width, height);

//       return new Promise<File | null>((resolve) => {
//         outputCanvas.toBlob((blob) => {
//           if (blob) resolve(new File([blob], "cropped.jpg", { type: "image/jpeg" }));
//           else resolve(null);
//         }, "image/jpeg");
//       });
//     } catch (e) {
//       console.error("Crop error:", e);
//       return null;
//     }
//   };

//   const handleSave = async () => {
//     const croppedFile = await getCroppedImg();
//     if (croppedFile) {
//       const croppedUrl = URL.createObjectURL(croppedFile);
//       setImageSrc(croppedUrl);
//       onSave(croppedFile);
//       onClose();
//     }
//   };

//   return (
//     <Modal open={open} onClose={onClose}>
//       <Box
//         sx={{
//           position: "absolute",
//           top: "50%",
//           left: "50%",
//           transform: "translate(-50%, -50%)",
//           width: 500,
//           height: 700,
//           bgcolor: "white",
//           boxShadow: 24,
//           p: 2,
//         }}
//       >
//         <div style={{ position: "relative", width: "100%", height: "80%", background: "#000" }}>
//           {cropMode ? (
//             <Cropper
//               image={imageSrc}
//               crop={crop}
//               zoom={zoom}
//               rotation={rotation}
//               aspect={aspect}
//               onCropChange={setCrop}
//               onRotationChange={setRotation}
//               onZoomChange={setZoom}
//               onCropComplete={onCropComplete}
//               cropShape="rect"
//               showGrid={true}
//               restrictPosition={false}
//             />
//           ) : (
//             <img
//               src={imageSrc}
//               alt="Preview"
//               style={{
//                 width: "100%",
//                 height: "100%",
//                 objectFit: "contain",
//                 transform: `rotate(${rotation}deg)`,
//               }}
//             />
//           )}
//         </div>

//         {cropMode && (
//           <Box mt={2} display="flex" justifyContent="center">
//             <ToggleButtonGroup
//               value={aspect || ""}
//               exclusive
//               onChange={(_, newAspect) => {
//                 if (newAspect !== null) setAspect(newAspect);
//               }}
//               aria-label="aspect ratio"
//             >
//               <ToggleButton value={1}>1:1</ToggleButton>
//               <ToggleButton value={4 / 3}>4:3</ToggleButton>
//               <ToggleButton value={16 / 9}>16:9</ToggleButton>
//               <ToggleButton value={9 / 16}>9:16</ToggleButton>
//             </ToggleButtonGroup>
//           </Box>
//         )}

//         <Box display="flex" justifyContent="space-around" alignItems="center" mt={2}>
//           <Button variant="outlined" onClick={onClose}>
//             Cancel
//           </Button>

//           {!cropMode && (
//             <Button variant="contained" onClick={() => setCropMode(true)}>
//               Crop
//             </Button>
//           )}

//           {cropMode && (
//             <Button variant="contained" onClick={handleSave}>
//               Save Crop
//             </Button>
//           )}

//           <Button variant="outlined" onClick={() => setRotation((r) => r + 90)}>
//             Rotate
//           </Button>
//         </Box>

//         <Box className="w-100 border d-block">
//           {!cropMode && rotation !== 0 && (
//             <Button
//               variant="contained"
//               className="d-block w-100"
//               onClick={handleSave}
//             >
//               Save Rotation
//             </Button>
//           )}
//         </Box>
//       </Box>
//     </Modal>
//   );
// };

// export default CropperModal;













